<div class="d-flex justify-content-between align-items-end pb-3 px-3 autocomlete-header">
  <!-- <h2 mat-dialog-title class="dialog-heading">Add External Participant</h2> -->
  <h1 mat-dialog-title class="text-black fw-medium p-0 mb-0">Add External Participant</h1>

  <button class="border-0 bg-transparent delete-btn" (click)="onClose()">
    <i class="das das-corss fs-12 close-btn"></i>
  </button>
</div>

<mat-dialog-content class="dialog-content">
  <form [formGroup]="externalForm" class="px-3">
    <div class="form-row">
      <div class="field-wrapper full-width">
        <mat-label class="gray_text fs-14"
          >{{ 'eventForm.formFields.fullName' | translate }}<sup class="text-danger fs-12">*</sup>
        </mat-label>
        <mat-form-field appearance="outline" class="full-width">
          <input matInput class="fs-14" formControlName="fullName" required />
          @if (showError('fullName', 'required')) {
            <mat-error>{{ 'eventForm.validations.image' | translate }}</mat-error>
          }
        </mat-form-field>
      </div>

      <div class="field-wrapper full-width">
        <mat-label class="gray_text fs-14"
          >{{ 'login.formLabels.email' | translate }}<sup class="text-danger fs-12">*</sup>
        </mat-label>
        <mat-form-field appearance="outline" class="full-width">
          <input matInput class="fs-14" type="email" formControlName="email" required />
          @if (showError('email', 'required')) {
            <mat-error>{{ 'eventForm.validations.image' | translate }}</mat-error>
          }
          @if (showError('email', 'email')) {
            <mat-error>{{ 'login.formLabels.valid-Email' | translate }}</mat-error>
          }
        </mat-form-field>
      </div>
    </div>

    <div class="form-row">
      <div class="field-wrapper full-width">
        <mat-label class="gray_text fs-14"
          >{{ 'lmsAccessMng.designation' | translate }}<sup class="text-danger fs-12">*</sup>
        </mat-label>
        <mat-form-field appearance="outline" class="full-width">
          <input matInput class="fs-14" formControlName="designation" required />
          @if (showError('designation', 'required')) {
            <mat-error>{{ 'eventForm.validations.image' | translate }}</mat-error>
          }
        </mat-form-field>
      </div>

      <div class="field-wrapper full-width">
        <educare-file-upload
          [config]="fileUploadConfig"
          [existingImageUrl]="imageUrl"
          [formControl]="$any(imageUrlControl)"
          (fileSelected)="onFileSelected($event)"
          (fileRemoved)="onFileRemoved()"
        ></educare-file-upload>
      </div>
    </div>

    <div class="form-row">
      <div class="field-wrapper full-width">
        <mat-label class="gray_text fs-14"
          >{{ 'eventForm.formFields.bio' | translate }}<sup class="text-danger fs-12">*</sup>
        </mat-label>
        <educare-rich-text-editor
          [content]="externalForm.get('bio')?.value"
          (contentChange)="onBioChanged($event)"
        ></educare-rich-text-editor>
        @if (showError('bio', 'required')) {
          <mat-error>{{ 'eventForm.validations.image' | translate }}</mat-error>
        }
      </div>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions class="px-3 pb-3 pt-3 d-flex gap-3" align="end">
  <button
    class="btn rounded-1 fs-14 btn-primary px-5 fw-bold white-space-nowrap"
    (click)="onSave()"
    [disabled]="submitted"
  >
    {{ 'userInfo.save' | translate }}
  </button>
  <button class="btn btn-outline-primary fw-bold px-5 fs-14 rounded-1" (click)="onClose()">
    {{ 'snackbar.cancel' | translate }}
  </button>
</mat-dialog-actions>
